import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}
//获取sso域名（未登录）
export function getssoUrl( params) {
  return request({ 
    url: '/siteInfo' ,
    method: 'get',
    params
  })
}
//渠道信息全量查询（已登录）
export function getChannelSiteInfo(data) {
  return request({ 
    url: '/channelSite/info' ,
    method: 'post',
    data
  })
}
export function ssologion(data) {
  return request({
    url: '/ssologin',
    method: 'post',
    data
  })
}
export function getInfo() {
  return request({
    url: '/channel',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function authInfo() {
  return request({
    url: '/oem/getAuthInfo',
    method: 'get'
  })
}

export function getBaseSettingTitle(params) {
  return request({
    url: '/oem/getBaseSettingTitle',
    method: 'get',
    params
  })
}

export function getuserinfo(params) {
  return request({
    url: '/agent/auth',
    method: 'get',
    params
  })
}